import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { initializeI18n } from "./lib/i18n";
import "./styles.css";

const root = document.getElementById("root");

if (!root) {
  throw new Error("Root element #root is missing");
}

initializeI18n().then(() => {
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
